<template>
  <div>
    <div class="p-2 mb-5 has-text-grey has-text-centered notification is-warning is-light">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
    name: 'OutOfPolicyTag',
    props: {
        hiddenItemsCount: Number,
    },
    mounted () {
    },
    methods: {

    },
    computed: {
      message() {
        let resultLabel = this.hiddenItemsCount == 1 ? 'result is' : 'results are'
        return this.hiddenItemsCount + ' ' + resultLabel + ' hidden because of travel policy restrictions.'
      }
    }
}
</script>


<style scoped>

</style>
